<template>
  <footer class="footer">
    <div class="container container--content">
      <a href="/" class="footer__logo">
        <svg
          width="203"
          height="26"
          viewBox="0 0 203 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.9603 15.892C11.9603 15.364 11.9243 14.824 11.8523 14.272C11.8043 13.72 11.6603 13.216 11.4203 12.76C11.1803 12.304 10.8083 11.932 10.3043 11.644C9.82427 11.332 9.14027 11.176 8.25227 11.176C7.36427 11.176 6.66827 11.332 6.16427 11.644C5.68427 11.932 5.32427 12.304 5.08427 12.76C4.84427 13.216 4.68827 13.72 4.61627 14.272C4.56827 14.824 4.54427 15.364 4.54427 15.892V25H0.152266V15.892C0.152266 14.644 0.260266 13.552 0.476266 12.616C0.716266 11.68 1.02827 10.876 1.41227 10.204C1.79627 9.508 2.22827 8.932 2.70827 8.476C3.18827 8.02 3.68027 7.648 4.18427 7.36C5.36027 6.688 6.71627 6.328 8.25227 6.28C9.76427 6.328 11.1083 6.688 12.2843 7.36C12.7883 7.648 13.2803 8.02 13.7603 8.476C14.2643 8.932 14.6963 9.508 15.0563 10.204C15.4403 10.876 15.7523 11.68 15.9923 12.616C16.2323 13.552 16.3523 14.644 16.3523 15.892V25H11.9603V15.892ZM23.7683 15.892C23.7683 15.364 23.7323 14.824 23.6603 14.272C23.6123 13.72 23.4683 13.216 23.2283 12.76C22.9883 12.304 22.6163 11.932 22.1123 11.644C21.6323 11.332 20.9483 11.176 20.0603 11.176C19.1723 11.176 18.4763 11.332 17.9723 11.644C17.4923 11.932 17.1323 12.304 16.8923 12.76C16.6523 13.216 16.4963 13.72 16.4243 14.272C16.3763 14.824 16.3523 15.364 16.3523 15.892V25H11.9603V15.892C11.9603 14.644 12.0683 13.552 12.2843 12.616C12.5243 11.68 12.8363 10.876 13.2203 10.204C13.6043 9.508 14.0363 8.932 14.5163 8.476C14.9963 8.02 15.4883 7.648 15.9923 7.36C17.1683 6.688 18.5243 6.328 20.0603 6.28C21.5723 6.328 22.9163 6.688 24.0923 7.36C24.5963 7.648 25.0883 8.02 25.5683 8.476C26.0723 8.932 26.5043 9.508 26.8643 10.204C27.2483 10.876 27.5603 11.68 27.8003 12.616C28.0403 13.552 28.1603 14.644 28.1603 15.892V25H23.7683V15.892ZM47.2723 13.552C47.3203 13.912 47.3563 14.284 47.3803 14.668C47.4283 15.052 47.4523 15.46 47.4523 15.892V16.54H34.8523C34.9003 16.948 34.9603 17.368 35.0323 17.8C35.1043 18.208 35.2243 18.616 35.3923 19.024C35.6563 19.648 36.0643 20.2 36.6163 20.68C37.1683 21.16 37.9363 21.4 38.9203 21.4C39.9043 21.4 40.6723 21.16 41.2243 20.68C41.7763 20.2 42.1843 19.648 42.4483 19.024H47.1283C46.9363 19.864 46.6603 20.596 46.3003 21.22C45.9643 21.844 45.5803 22.384 45.1483 22.84C44.7403 23.296 44.2963 23.68 43.8163 23.992C43.3363 24.28 42.8683 24.52 42.4123 24.712C41.3083 25.144 40.1443 25.36 38.9203 25.36C37.3123 25.336 35.8843 25 34.6363 24.352C34.1083 24.064 33.5803 23.704 33.0523 23.272C32.5483 22.816 32.0923 22.252 31.6843 21.58C31.3003 20.908 30.9883 20.104 30.7483 19.168C30.5083 18.232 30.3883 17.14 30.3883 15.892C30.3883 14.644 30.5083 13.552 30.7483 12.616C30.9883 11.68 31.3003 10.876 31.6843 10.204C32.0923 9.508 32.5483 8.932 33.0523 8.476C33.5803 8.02 34.1083 7.648 34.6363 7.36C35.8843 6.688 37.3123 6.328 38.9203 6.28C40.2403 6.328 41.4763 6.604 42.6283 7.108C43.1083 7.324 43.5883 7.612 44.0683 7.972C44.5723 8.308 45.0283 8.74 45.4363 9.268C45.8683 9.772 46.2403 10.384 46.5523 11.104C46.8883 11.8 47.1283 12.616 47.2723 13.552ZM42.7363 13.552C42.6163 13.168 42.4603 12.784 42.2683 12.4C42.1003 12.016 41.8603 11.668 41.5483 11.356C41.2363 11.044 40.8643 10.804 40.4323 10.636C40.0003 10.444 39.4963 10.348 38.9203 10.348C38.3443 10.348 37.8403 10.444 37.4083 10.636C36.9763 10.804 36.6043 11.044 36.2923 11.356C35.9803 11.668 35.7283 12.016 35.5363 12.4C35.3443 12.784 35.2003 13.168 35.1043 13.552H42.7363ZM57.7523 6.28C57.8243 6.28 58.0763 6.292 58.5083 6.316C58.9643 6.34 59.4923 6.448 60.0923 6.64C60.6923 6.808 61.3283 7.084 62.0003 7.468C62.6723 7.852 63.2963 8.404 63.8723 9.124C64.4483 9.844 64.9163 10.756 65.2763 11.86C65.6603 12.94 65.8523 14.284 65.8523 15.892V25H61.4603V15.892C61.4603 15.364 61.4123 14.824 61.3163 14.272C61.2203 13.72 61.0403 13.216 60.7763 12.76C60.5123 12.304 60.1403 11.932 59.6603 11.644C59.1803 11.332 58.5443 11.176 57.7523 11.176C56.9603 11.176 56.3243 11.332 55.8443 11.644C55.3643 11.932 54.9923 12.304 54.7283 12.76C54.4643 13.216 54.2843 13.72 54.1883 14.272C54.0923 14.824 54.0443 15.364 54.0443 15.892V25H49.6523V15.892C49.6523 14.284 49.8323 12.94 50.1923 11.86C50.5763 10.756 51.0563 9.844 51.6323 9.124C52.2083 8.404 52.8323 7.852 53.5043 7.468C54.1763 7.084 54.8123 6.808 55.4123 6.64C56.0123 6.448 56.5283 6.34 56.9603 6.316C57.3923 6.292 57.6563 6.28 57.7523 6.28ZM72.5398 11.032V19.06C72.6118 19.348 72.7438 19.612 72.9358 19.852C73.1038 20.044 73.3318 20.224 73.6198 20.392C73.9318 20.56 74.3278 20.644 74.8078 20.644H77.5438V25H73.1518C72.2158 24.904 71.3758 24.64 70.6318 24.208C70.0078 23.848 69.4318 23.32 68.9038 22.624C68.3998 21.904 68.1478 20.92 68.1478 19.672V1.852H72.5398V6.748H76.6798V11.032H72.5398ZM96.5271 25H92.2431V22.48L93.0351 21.436C92.6271 22.444 92.1111 23.212 91.4871 23.74C90.8631 24.268 90.2511 24.652 89.6511 24.892C88.9551 25.156 88.2351 25.312 87.4911 25.36C86.0031 25.336 84.6831 25 83.5311 24.352C83.0271 24.064 82.5351 23.704 82.0551 23.272C81.5991 22.816 81.1791 22.252 80.7951 21.58C80.4351 20.908 80.1351 20.104 79.8951 19.168C79.6791 18.232 79.5711 17.14 79.5711 15.892C79.5711 14.644 79.6911 13.552 79.9311 12.616C80.1711 11.68 80.4831 10.876 80.8671 10.204C81.2751 9.508 81.7311 8.932 82.2351 8.476C82.7631 8.02 83.2911 7.648 83.8191 7.36C85.0671 6.688 86.4951 6.328 88.1031 6.28C89.6151 6.28 90.8991 6.508 91.9551 6.964C93.0111 7.396 93.8751 8.032 94.5471 8.872C95.2431 9.688 95.7471 10.696 96.0591 11.896C96.3711 13.072 96.5271 14.416 96.5271 15.928V25ZM88.1031 10.528C87.2151 10.528 86.4951 10.708 85.9431 11.068C85.4151 11.428 85.0071 11.884 84.7191 12.436C84.4311 12.964 84.2391 13.54 84.1431 14.164C84.0471 14.788 83.9991 15.364 83.9991 15.892C83.9991 16.42 84.0471 16.996 84.1431 17.62C84.2391 18.244 84.4311 18.832 84.7191 19.384C85.0071 19.912 85.4151 20.356 85.9431 20.716C86.4951 21.076 87.2151 21.256 88.1031 21.256C88.9911 21.256 89.6991 21.076 90.2271 20.716C90.7791 20.356 91.1991 19.912 91.4871 19.384C91.7991 18.832 92.0031 18.244 92.0991 17.62C92.1951 16.996 92.2431 16.42 92.2431 15.892C92.2431 15.244 92.1951 14.608 92.0991 13.984C92.0271 13.336 91.8471 12.76 91.5591 12.256C91.2951 11.728 90.8871 11.308 90.3351 10.996C89.7831 10.684 89.0391 10.528 88.1031 10.528ZM103.302 0.7V25H98.9104V0.7H103.302ZM121.318 8.044V12.112H117.538V25H113.254V6.028C113.254 4.78 113.506 3.808 114.01 3.112C114.538 2.392 115.114 1.852 115.738 1.492C116.482 1.06 117.322 0.796 118.258 0.7H123.298V4.768H119.914C119.338 4.768 118.894 4.864 118.582 5.056C118.27 5.248 118.03 5.464 117.862 5.704C117.67 5.968 117.562 6.28 117.538 6.64V8.044H121.318ZM133.409 25.36C133.337 25.36 133.073 25.348 132.617 25.324C132.185 25.3 131.669 25.192 131.069 25C130.469 24.832 129.833 24.556 129.161 24.172C128.489 23.788 127.865 23.236 127.289 22.516C126.713 21.796 126.233 20.896 125.849 19.816C125.489 18.712 125.309 17.356 125.309 15.748V6.748H129.701V15.748C129.701 16.276 129.749 16.816 129.845 17.368C129.941 17.92 130.121 18.424 130.385 18.88C130.649 19.336 131.021 19.72 131.501 20.032C131.981 20.32 132.617 20.464 133.409 20.464C134.201 20.464 134.837 20.32 135.317 20.032C135.797 19.72 136.169 19.336 136.433 18.88C136.697 18.424 136.877 17.92 136.973 17.368C137.069 16.816 137.117 16.276 137.117 15.748V6.748H141.509V15.748C141.509 17.356 141.317 18.712 140.933 19.816C140.573 20.896 140.105 21.796 139.529 22.516C138.953 23.236 138.329 23.788 137.657 24.172C136.985 24.556 136.349 24.832 135.749 25C135.149 25.192 134.621 25.3 134.165 25.324C133.733 25.348 133.481 25.36 133.409 25.36ZM148.196 11.032V19.06C148.268 19.348 148.4 19.612 148.592 19.852C148.76 20.044 148.988 20.224 149.276 20.392C149.588 20.56 149.984 20.644 150.464 20.644H153.2V25H148.808C147.872 24.904 147.032 24.64 146.288 24.208C145.664 23.848 145.088 23.32 144.56 22.624C144.056 21.904 143.804 20.92 143.804 19.672V1.852H148.196V6.748H152.336V11.032H148.196ZM163.291 25.36C163.219 25.36 162.955 25.348 162.499 25.324C162.067 25.3 161.551 25.192 160.951 25C160.351 24.832 159.715 24.556 159.043 24.172C158.371 23.788 157.747 23.236 157.171 22.516C156.595 21.796 156.115 20.896 155.731 19.816C155.371 18.712 155.191 17.356 155.191 15.748V6.748H159.583V15.748C159.583 16.276 159.631 16.816 159.727 17.368C159.823 17.92 160.003 18.424 160.267 18.88C160.531 19.336 160.903 19.72 161.383 20.032C161.863 20.32 162.499 20.464 163.291 20.464C164.083 20.464 164.719 20.32 165.199 20.032C165.679 19.72 166.051 19.336 166.315 18.88C166.579 18.424 166.759 17.92 166.855 17.368C166.951 16.816 166.999 16.276 166.999 15.748V6.748H171.391V15.748C171.391 17.356 171.199 18.712 170.815 19.816C170.455 20.896 169.987 21.796 169.411 22.516C168.835 23.236 168.211 23.788 167.539 24.172C166.867 24.556 166.231 24.832 165.631 25C165.031 25.192 164.503 25.3 164.047 25.324C163.615 25.348 163.363 25.36 163.291 25.36ZM173.615 12.076C173.615 10.828 173.879 9.856 174.407 9.16C174.935 8.44 175.511 7.9 176.135 7.54C176.879 7.108 177.719 6.844 178.655 6.748H183.695V11.104H180.311C179.831 11.104 179.435 11.188 179.123 11.356C178.835 11.524 178.607 11.704 178.439 11.896C178.247 12.136 178.115 12.4 178.043 12.688V25H173.615V12.076ZM202.628 13.552C202.676 13.912 202.712 14.284 202.736 14.668C202.784 15.052 202.808 15.46 202.808 15.892V16.54H190.208C190.256 16.948 190.316 17.368 190.388 17.8C190.46 18.208 190.58 18.616 190.748 19.024C191.012 19.648 191.42 20.2 191.972 20.68C192.524 21.16 193.292 21.4 194.276 21.4C195.26 21.4 196.028 21.16 196.58 20.68C197.132 20.2 197.54 19.648 197.804 19.024H202.484C202.292 19.864 202.016 20.596 201.656 21.22C201.32 21.844 200.936 22.384 200.504 22.84C200.096 23.296 199.652 23.68 199.172 23.992C198.692 24.28 198.224 24.52 197.768 24.712C196.664 25.144 195.5 25.36 194.276 25.36C192.668 25.336 191.24 25 189.992 24.352C189.464 24.064 188.936 23.704 188.408 23.272C187.904 22.816 187.448 22.252 187.04 21.58C186.656 20.908 186.344 20.104 186.104 19.168C185.864 18.232 185.744 17.14 185.744 15.892C185.744 14.644 185.864 13.552 186.104 12.616C186.344 11.68 186.656 10.876 187.04 10.204C187.448 9.508 187.904 8.932 188.408 8.476C188.936 8.02 189.464 7.648 189.992 7.36C191.24 6.688 192.668 6.328 194.276 6.28C195.596 6.328 196.832 6.604 197.984 7.108C198.464 7.324 198.944 7.612 199.424 7.972C199.928 8.308 200.384 8.74 200.792 9.268C201.224 9.772 201.596 10.384 201.908 11.104C202.244 11.8 202.484 12.616 202.628 13.552ZM198.092 13.552C197.972 13.168 197.816 12.784 197.624 12.4C197.456 12.016 197.216 11.668 196.904 11.356C196.592 11.044 196.22 10.804 195.788 10.636C195.356 10.444 194.852 10.348 194.276 10.348C193.7 10.348 193.196 10.444 192.764 10.636C192.332 10.804 191.96 11.044 191.648 11.356C191.336 11.668 191.084 12.016 190.892 12.4C190.7 12.784 190.556 13.168 190.46 13.552H198.092Z"
            fill="white"
          />
        </svg>
      </a>
      <div class="footer__wrapper">
        <ul class="footer__block footer__block--links">
          <li class="footer__item">
            <a href="#" class="footer__link"> Home </a>
          </li>
          <li class="footer__item">
            <a href="#" class="footer__link"> Magazine </a>
          </li>
          <li class="footer__item">
            <a href="#" class="footer__link"> Jobs </a>
          </li>
          <li class="footer__item">
            <router-link to="/login" class="footer__link">
              Login To Web App
            </router-link>
          </li>
        </ul>
        <div class="footer__block footer__block--more">
          <h3 class="footer__title">More</h3>
          <ul class="footer__list">
            <li class="footer__item">
              <router-link to="/terms-of-service" class="footer__link">
                Terms Of Service
              </router-link>
            </li>
            <li class="footer__item">
              <router-link to="privacy-policy" class="footer__link">
                Privacy Policy
              </router-link>
            </li>
            <li class="footer__item">
              <router-link to="faq" class="footer__link"> FAQ </router-link>
            </li>
          </ul>
        </div>
        <div class="footer__block footer__block--started">
          <h3 class="footer__title">Get Started</h3>
          <router-link to="/quiz" class="footer__start-quiz start-quiz-link">
            <span class="start-quiz-link__text">Start my quiz</span>
          </router-link>
          <ul class="footer__list-app">
            <li class="footer__item-app">
              <a
                href="https://apps.apple.com/us/app/mental-future-mind-relief/id1616660224"
                target="_blank"
                class="footer__link-app"
              >
                <span class="footer__link-icon">
                  <svg
                    width="19"
                    height="24"
                    viewBox="0 0 19 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.8199 12.7898C15.8268 11.9542 16.0472 11.1343 16.4603 10.4079C16.8734 9.68156 17.4653 9.07289 18.1799 8.63978C17.7245 7.99603 17.1266 7.46617 16.4328 7.0915C15.7389 6.71683 14.968 6.50748 14.1799 6.47977C12.4799 6.30977 10.8699 7.47977 10.0099 7.47977C9.14993 7.47977 7.81992 6.47977 6.40992 6.52977C5.486 6.55473 4.58445 6.81951 3.79377 7.29813C3.00309 7.77675 2.35043 8.45275 1.89991 9.25977C-0.0200892 12.5998 1.40992 17.5398 3.27992 20.2598C4.19992 21.5898 5.27992 23.0698 6.71992 23.0198C8.15992 22.9698 8.62993 22.1298 10.2899 22.1298C11.9499 22.1298 12.4299 23.0198 13.8899 22.9898C15.3499 22.9598 16.3199 21.6398 17.2299 20.3198C17.8748 19.3616 18.383 18.3182 18.7399 17.2198C17.8739 16.8469 17.136 16.2288 16.6172 15.4416C16.0983 14.6544 15.8212 13.7326 15.8199 12.7898Z"
                      fill="white"
                    />
                    <path
                      d="M13.2602 3.67C14.1269 2.65237 14.5548 1.33261 14.4502 0C13.1407 0.130171 11.9293 0.751962 11.0601 1.74001C10.6303 2.2225 10.3011 2.78586 10.0916 3.39713C9.88209 4.0084 9.79662 4.6553 9.84014 5.3C10.4968 5.30751 11.1465 5.16451 11.7393 4.88196C12.3322 4.59941 12.8524 4.18482 13.2602 3.67Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Download iOS App
              </a>
            </li>
            <li class="footer__item-app">
              <a
                href="https://play.google.com/store/apps/details?id=com.mental.future.meditation.cbt"
                target="_blank"
                class="footer__link-app"
              >
                <span class="footer__link-icon">
                  <svg
                    width="22"
                    height="21"
                    viewBox="0 0 22 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_2473_2461)">
                      <path
                        d="M2.37002 20.6592L13.37 10.2992L2.26002 0.0192001C1.97413 -0.0227133 1.68255 -0.00218206 1.40536 0.0793808C1.12816 0.160944 0.871937 0.301602 0.654306 0.491673C0.436675 0.681744 0.262804 0.916697 0.144678 1.18039C0.026551 1.44409 -0.0330305 1.73027 -0.0299744 2.0192V18.7192C-0.0351083 19.0161 0.0259247 19.3104 0.148706 19.5808C0.271487 19.8511 0.452933 20.0908 0.679864 20.2823C0.906796 20.4738 1.17353 20.6123 1.46069 20.6879C1.74784 20.7635 2.04822 20.7742 2.34002 20.7192L2.37002 20.6592Z"
                        fill="white"
                      />
                      <path
                        d="M17.0701 6.8607L5.06006 1.2207L14.1301 9.6207L17.0701 6.8607Z"
                        fill="white"
                      />
                      <path
                        d="M14.1399 10.9902L5.1499 19.4302L17.1599 13.7902L14.1399 10.9902Z"
                        fill="white"
                      />
                      <path
                        d="M20.6401 8.53058L18.0501 7.31055L14.8701 10.3105L18.1401 13.3105L20.6401 12.1406C20.9837 11.9791 21.2742 11.7231 21.4777 11.4026C21.6812 11.0821 21.7893 10.7102 21.7893 10.3306C21.7893 9.95091 21.6812 9.57912 21.4777 9.25861C21.2742 8.93809 20.9837 8.68208 20.6401 8.52057V8.53058Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2473_2461">
                        <rect width="21.79" height="20.7" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Download Android App
              </a>
            </li>
          </ul>
        </div>
        <div class="footer__block footer__block--follow">
          <h3 class="footer__title">Follow Us</h3>
          <ul class="footer__list-social">
            <li class="footer__list-social-item">
              <a
                href="https://www.facebook.com/mentalfuture.official/"
                target="blank"
                class="footer__list-social-link footer__list-social-link--facebook"
              >
                <svg
                  width="8"
                  height="15"
                  viewBox="0 0 8 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.8767 8.21947L7.2594 5.57347H4.87493V3.85953C4.85828 3.66233 4.88361 3.46368 4.94903 3.27829C5.01445 3.0929 5.11829 2.92551 5.25286 2.78854C5.38743 2.65158 5.54928 2.54853 5.72642 2.48704C5.90356 2.42555 6.09145 2.40719 6.27618 2.43332H7.35949V0.181409C6.72287 0.0702679 6.07934 0.00962714 5.43424 0C3.46779 0 2.1843 1.25106 2.1843 3.55927V5.5985H0V8.2445H2.1843V14.6061C3.07561 14.7563 3.98362 14.7563 4.87493 14.6061V8.21947H6.8767Z"
                    fill="white"
                  />
                </svg>
              </a>
            </li>
            <li class="footer__list-social-item">
              <a
                href="https://www.instagram.com/mentalfuture/"
                target="blank"
                class="footer__list-social-link footer__list-social-link--instagram"
              >
                <svg
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7122 2.49219C10.5505 2.49219 10.3924 2.53996 10.258 2.62947C10.1235 2.71899 10.0187 2.84623 9.95678 2.99509C9.89489 3.14395 9.87869 3.30774 9.91024 3.46578C9.94179 3.62381 10.0197 3.76897 10.134 3.88291C10.2484 3.99684 10.3941 4.07443 10.5527 4.10587C10.7114 4.1373 10.8758 4.12116 11.0252 4.0595C11.1746 3.99784 11.3023 3.89344 11.3922 3.75947C11.482 3.6255 11.53 3.46799 11.53 3.30686C11.53 3.09079 11.4438 2.88357 11.2905 2.73079C11.1371 2.57801 10.9291 2.49219 10.7122 2.49219Z"
                    fill="white"
                  />
                  <path
                    d="M7.05625 3.54297C6.37375 3.54297 5.70657 3.74461 5.1391 4.12239C4.57162 4.50016 4.12933 5.03708 3.86815 5.66529C3.60696 6.2935 3.53863 6.98479 3.67178 7.65169C3.80493 8.3186 4.13357 8.93118 4.61617 9.41199C5.09877 9.89281 5.71364 10.2202 6.38302 10.3529C7.05241 10.4855 7.74624 10.4175 8.37679 10.1572C9.00734 9.89703 9.54629 9.45638 9.92546 8.891C10.3046 8.32563 10.507 7.66093 10.507 6.98096C10.507 6.52947 10.4178 6.08241 10.2443 5.66529C10.0709 5.24818 9.81675 4.86919 9.49631 4.54994C9.17588 4.2307 8.79546 3.97744 8.37679 3.80467C7.95812 3.63189 7.50942 3.54297 7.05625 3.54297ZM7.05625 9.18063C6.61993 9.17902 6.19387 9.04863 5.83187 8.80595C5.46987 8.56327 5.18816 8.21918 5.02231 7.8171C4.85645 7.41503 4.81389 6.97301 4.9 6.54686C4.98612 6.12071 5.19704 5.72952 5.50613 5.42271C5.81523 5.1159 6.20863 4.9072 6.63669 4.82298C7.06474 4.73876 7.50825 4.78281 7.91121 4.94953C8.31416 5.11625 8.6585 5.39819 8.90074 5.75974C9.14298 6.1213 9.27227 6.54625 9.27227 6.98096C9.27227 7.27051 9.21489 7.55723 9.10343 7.82463C8.99196 8.09204 8.8286 8.33489 8.62272 8.53925C8.41684 8.74362 8.17248 8.90548 7.90367 9.01554C7.63486 9.1256 7.34688 9.1817 7.05625 9.18063Z"
                    fill="white"
                  />
                  <path
                    d="M9.80447 13.9639H4.21126C3.09503 13.9617 2.02514 13.519 1.23584 12.7326C0.446543 11.9462 0.00216115 10.8803 0 9.76819V4.19568C0.00216115 3.08357 0.446543 2.01762 1.23584 1.23124C2.02514 0.444866 3.09503 0.00215316 4.21126 0H9.80447C10.9207 0.00215316 11.9906 0.444866 12.7799 1.23124C13.5692 2.01762 14.0136 3.08357 14.0157 4.19568V9.76819C14.0136 10.8803 13.5692 11.9462 12.7799 12.7326C11.9906 13.519 10.9207 13.9617 9.80447 13.9639ZM4.20307 1.31165C3.43601 1.3138 2.70097 1.61835 2.15857 2.15874C1.61617 2.69913 1.31049 3.43145 1.30833 4.19568V9.76819C1.31049 10.5324 1.61617 11.2647 2.15857 11.8051C2.70097 12.3455 3.43601 12.6501 4.20307 12.6522H9.80447C10.5715 12.6501 11.3066 12.3455 11.849 11.8051C12.3914 11.2647 12.697 10.5324 12.6992 9.76819V4.19568C12.697 3.43145 12.3914 2.69913 11.849 2.15874C11.3066 1.61835 10.5715 1.3138 9.80447 1.31165H4.20307Z"
                    fill="white"
                  />
                </svg>
              </a>
            </li>
            <li class="footer__list-social-item">
              <a
                href="https://www.tiktok.com/@mental.future"
                target="blank"
                class="footer__list-social-link footer__list-social-link--tiktok"
              >
                <svg
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.1571 6.63081H12.7891C12.1253 6.63151 11.4718 6.46724 10.8878 6.15286C10.3039 5.83848 9.80779 5.38394 9.44461 4.83038V10.9567C9.44461 11.8526 9.17797 12.7284 8.67839 13.4732C8.17882 14.2181 7.46873 14.7987 6.63796 15.1415C5.80719 15.4844 4.89305 15.5741 4.01111 15.3993C3.12917 15.2245 2.31907 14.7931 1.68322 14.1596C1.04738 13.5262 0.614351 12.7191 0.438923 11.8404C0.263494 10.9618 0.353539 10.051 0.697655 9.22333C1.04177 8.39565 1.6245 7.68824 2.37218 7.19052C3.11985 6.6928 3.99886 6.42714 4.89808 6.42714H5.1761V8.65936C5.08615 8.65936 4.99621 8.65936 4.89808 8.65936C4.58207 8.64065 4.26557 8.6865 3.96799 8.79411C3.67041 8.90172 3.39806 9.06881 3.16766 9.28511C2.93727 9.50141 2.75369 9.76236 2.62821 10.0519C2.50274 10.3415 2.43803 10.6536 2.43803 10.969C2.43803 11.2843 2.50274 11.5964 2.62821 11.886C2.75369 12.1755 2.93727 12.4365 3.16766 12.6528C3.39806 12.8691 3.67041 13.0362 3.96799 13.1438C4.26557 13.2514 4.58207 13.2973 4.89808 13.2785C5.20954 13.2894 5.5201 13.2391 5.812 13.1303C6.10391 13.0215 6.37142 12.8565 6.59926 12.6446C6.82709 12.4328 7.0108 12.1782 7.13983 11.8956C7.26886 11.613 7.34069 11.3078 7.35124 10.9975V0.585938H9.49369C9.59105 1.51412 10.013 2.3786 10.6858 3.028C11.3585 3.67739 12.2392 4.07029 13.1734 4.1379V6.62268"
                    fill="white"
                  />
                </svg>
              </a>
            </li>
            <li class="footer__list-social-item">
              <a
                href="https://www.youtube.com/c/MentalFuture"
                target="blank"
                class="footer__list-social-link footer__list-social-link--youtube"
              >
                <svg
                  width="14"
                  height="10"
                  viewBox="0 0 14 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5999 3.35956C13.5999 2.60116 13.2975 1.87383 12.7592 1.33756C12.221 0.801291 11.4909 0.5 10.7297 0.5H3.37018C2.60896 0.5 1.87892 0.801291 1.34065 1.33756C0.802388 1.87383 0.5 2.60116 0.5 3.35956V6.75682C0.499997 7.51597 0.802122 8.24414 1.34016 8.7817C1.87819 9.31927 2.60821 9.62236 3.37018 9.62451H10.7297C11.4917 9.62236 12.2217 9.31927 12.7597 8.7817C13.2978 8.24414 13.5999 7.51597 13.5999 6.75682V3.35956ZM9.28232 5.31481L6.01143 6.94418C5.8806 7.0175 5.4472 6.94419 5.4472 6.77311V3.44104C5.4472 3.29439 5.88878 3.20477 6.01962 3.27809L9.16785 4.98078C9.27415 5.0541 9.41315 5.24149 9.28232 5.31481Z"
                    fill="white"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer__copyright">
        <p class="footer__copyright-text">© Mental Future 2022</p>
        <p class="footer__copyright-text">
          Contact us:
          <a href="mailto:help@mentalfuture.com" class="footer__copyright-link">
            help@mentalfuture.com
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.footer {
  &__logo {
    display: flex;
    margin-bottom: 72px;

    @media (max-width: 576px) {
      justify-content: center;
      margin-bottom: 52px;
    }
  }

  &__wrapper {
    display: flex;
    margin-bottom: 90px;

    @media (min-width: 992px) {
      justify-content: space-between;
    }

    @media (max-width: 991px) {
      flex-wrap: wrap;
      margin-bottom: 0;
    }
  }

  &__block {
    @media (max-width: 991px) {
      flex: 1 0 calc(50% - 10px);
      max-width: calc(50% - 10px);
      margin-bottom: 52px;
    }

    @media (max-width: 576px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1 1 100%;
      max-width: 100%;
    }
  }

  &__item {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  &__link {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: var(--color-white);

    &:hover,
    &:focus {
      opacity: 0.6;
    }
  }

  &__title {
    font-family: var(--run);
    font-weight: 500;
    font-size: 24px;
    text-transform: lowercase;
    color: var(--color-white);
    margin-top: 0;
    margin-bottom: 28px;
  }

  &__start-quiz {
    margin-bottom: 25px;

    @media (max-width: 576px) {
      max-width: 180px;
    }
  }

  &__list-app,
  &__list {
    @media (max-width: 576px) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &__item-app {
    &:not(:last-child) {
      margin-bottom: 25px;
    }
  }

  &__link-app {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: var(--color-white);
  }

  &__link-icon {
    display: inline-block;
    width: 22px;
    margin-right: 16px;
  }

  &__list-social {
    display: flex;
    align-items: center;
  }

  &__list-social-item {
    &:not(:last-child) {
      margin-right: 12px;
    }
  }

  &__list-social-link {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(#fff, 0.1);
    width: 36px;
    height: 36px;
    border-radius: 50%;

    &--facebook {
      svg {
        width: 11px;
        height: 22px;
      }
    }

    &--instagram {
      svg {
        width: 21px;
        height: 21px;
      }
    }

    &--tiktok {
      svg {
        width: 20px;
        height: 22px;
      }
    }

    &--youtube {
      svg {
        width: 20px;
        height: 14px;
      }
    }

    &:hover,
    &:focus {
      svg {
        path {
          fill: rgba(255, 255, 255, 0.6);
        }
      }
    }
  }

  &__copyright {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgba(#fff, 0.2);
    padding-top: 24px;
    padding-bottom: 52px;
    color: var(--color-white);

    @media (max-width: 767px) {
      flex-direction: column-reverse;
      padding-bottom: 28px;
    }
  }

  &__copyright-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    @media (max-width: 767px) {
      &:not(:first-child) {
        margin-bottom: 24px;
      }
    }
  }
}
</style>
